<template>
  <div :class="`tooltip ${position}`">
    <slot></slot>
    <span class="tooltip-text">
      <div v-for="(val,index) in allType" :key="index">
        <span v-if="!nShow.includes(val.label)">
          <strong>{{val.label}}:</strong>
          <span v-if="checkDateFormat(valMap[val.name]) && val.label === '生日'">{{valMap[val.name]}}</span>
          <span v-else-if="val.label === '生日'">{{valMap[val.name] | dateFormat}}</span>
          <span v-else> {{valMap[val.name]}}</span>
        </span>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    position: String,
    valMap: {type: Object, default:{}},
    allType: { type: Array, default: []}
  },data: () => ({
    //不顯示欄位
    nShow: ['要保人<br>被保人']
  }),
  methods: {
    checkDateFormat(value) {
      let validateEmptyA = /\d{4}\-/g;
      let validateEmptyB = /\d{4}\//g;
      if (
        !value ||
        value === "" ||
        value === "— —" ||
        !(validateEmptyA.test(value) || validateEmptyB.test(value))
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltip-text {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: black;
  text-align: left;
  border-radius: 6px;
  /* padding: 5px 0; */
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  font-family: Arial, Helvetica, sans-serif;
  padding: 20px !important;
  border: 1px solid #c2c4c7;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
/* Tooltip top content */
.top .tooltip-text {
  bottom: 100%;
  left: 50%;
  margin-left: -140px; /* 120/2 = 60 */
}
/* Tooltip right content */
.right .tooltip-text {
  top: -5px;
  left: 110%;
}
/* Tooltip bottom content */
.bottom .tooltip-text {
  top: 100%;
  left: 50%;
  margin-left: -140px; /* 120/2 = 60 */
}
/* Tooltip left content */
.left .tooltip-text {
  top: -5px;
  right: 110%;
}
.tooltip .tooltip-text::after {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}
/* Tooltip top arrow */
.top .tooltip-text::after {
  margin-left: -5px;
  left: 50%;
  top: 100%;
  border-color: #fff transparent transparent transparent;
}
/* Tooltip bottom arrow */
.bottom .tooltip-text::after {
  margin-left: -5px;
  bottom: 100%;
  left: 50%;
  border-color: transparent transparent #fff transparent;
}
/* Tooltip left arrow */
.left .tooltip-text::after {
  top: 50%;
  margin-top: -5px;
  left: 100%;
  border-color: transparent transparent transparent #fff;
}
/* Tooltip right arrow */
.right .tooltip-text::after {
  top: 50%;
  margin-top: -40px;
  right: 100%;
  border-color: transparent #fff transparent transparent;
}
.tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
